import React, { useState, useEffect } from 'react';
import './PrivacyNotice.css';

const PrivacyNotice = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const hasSeenNotice = localStorage.getItem('privacy_notice_seen');
        if (!hasSeenNotice) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('privacy_notice_seen', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="privacy-notice-overlay">
            <div className="privacy-notice-modal">
                <h2>🔒 Privacy & Confidentiality Notice</h2>
                <div className="privacy-notice-content">
                    <p>
                        <strong>Important:</strong> This health journal belongs to you. Your entries are confidential
                    </p>
                    <ul>
                        <li>✓ Your data is automatically saved to secure servers</li>
                        <li>✓ Your data can only be viewed by you</li>
                        <li>✓ You may choose to share your entries with a Dr. Within naturopath if you prefer to
                            have a discussion. Please note that this option is not automatic</li>
                        <li>✓ Printing has been disabled</li>
                    </ul>
                    <p className="privacy-notice-footer">
                        By continuing, you acknowledge that you understand these privacy measures.
                    </p>
                </div>
                <button onClick={handleAccept} className="privacy-notice-btn">
                    I Understand
                </button>
            </div>
        </div>
    );
};

export default PrivacyNotice;
